import { render, staticRenderFns } from "./QBenefitsSubmenu.vue?vue&type=template&id=ed04f810&"
import script from "./QBenefitsSubmenu.vue?vue&type=script&lang=js&"
export * from "./QBenefitsSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports